import React from "react";
import { List, ListItemButton, ListItemText } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  paths: { text: string; to: string }[];
}

const Navigator = ({ paths }: Props) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <List component="div">
      {paths.map((path) => (
        <ListItemButton onClick={() => navigate(path.to)} key={path.to} sx={{ px: 3 }}>
          <ListItemText
            primary={path.text}
            primaryTypographyProps={{
              variant: "subtitle2",
              color: pathname === path.to ? "primary" : undefined,
            }}
          />
        </ListItemButton>
      ))}
    </List>
  );
};

export default Navigator;
